<template>
  <div>
  <el-table :data="dataTable" stripe style="width: 100%" ref="dataTable" border v-loading="listLoading"
    @selection-change="handleSelectionChange">

    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="name" :label="$t('deviceControl.operatorId')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('chong-dian-zhan')"></af-table-column>
    <af-table-column prop="percentage" :label="$t('bai-fen-bi-0')"></af-table-column>
    <af-table-column prop="createTime" :label="$t('chuang-jian-shi-jian')"></af-table-column>
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">

        <el-button size="mini" @click="insertOrUpdate(scope.$index, scope.row)"
         >{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" @click="deletes(scope.$index, scope.row)"
         >{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
  </div>
</template>

<script>
  export default {
    name: "list",
    data() {
      return {}
    },
    props: {
      dataTable: {},
      listLoading: false,


    },
    methods: {

      insertOrUpdate(index, row) {

        this.$emit("insertOrUpdate", row)

      },
      deletes(index, row) {

        this.$emit("deletes", row)

      },
    handleSelectionChange(val) {

      this.$emit("handleSelectionChange", val)
    },
      }
    }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/stationPercentage/list.vue